import React, { useEffect, useState } from 'react';

export const HtmlEmbedView = ({ content }) => {
  const [html, setHtml] = useState('');

  useEffect(() => {
    try {
      setHtml(atob(content || ''));
    } catch (e) {
      console.error('Failed to decode html embed:', e);
      setHtml('');
    }
  }, [content]);

  return (
    <div className="html-embed-wrapper my-6" data-testid="html-embed-view">
      <iframe
        srcDoc={html}
        sandbox="allow-scripts"
        className="html-embed-frame w-full bg-white border border-border rounded-lg"
        title="Embedded HTML content"
      />
    </div>
  );
};

export default HtmlEmbedView;
